import * as React from "react";
import { Box, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import CustomChip from "../CustomChip";

interface Props {
  claim: any;
}

const ChargeLine: React.FC<Props> = ({ claim }) => {
  const images = React.useContext(ImagesContext);

  const hasErrors = claim?.total_diagnosis_codes > 8;

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "4px",
      }}
    >
      <Box className="claim-step-two-list-tile">
        <Box
          sx={{
            display: "flex",
            columnGap: "16px",
            alignItems: "center",
          }}
        >
          <div className="item-icon-container">
            <img
              src={hasErrors ? images.close_icon : images.check_mark_icon}
              alt="Insurance Icon"
              className="action-icon-image"
              style={{ width: 23, maxHeight: 23 }}
            />
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: "10px",
            }}
          >
            <Box display="flex" alignItems="center" columnGap="16px">
              <Typography
                sx={{
                  fontSize: "18px",
                  lineHeight: "18px",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  color: "#4A4442",
                }}
              >
                Charge Line
              </Typography>
              {hasErrors ? (
                <CustomChip label="Too Many Diagnosis Codes" type="error" />
              ) : (
                <CustomChip label="No Errors" />
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "18px",
                fontWeight: 500,
                letterSpacing: "1px",
                color: "#707070",
              }}
            >
              Charge Line Count: {claim?.total_charge_lines} • Diagnosis Codes:{" "}
              {claim?.total_diagnosis_codes}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChargeLine;
